export default __webpack_public_path__ + "static/media/realtors.dce35bf1.png";